<template>
  <div class="watermark" :style="watermarkStyle"></div>
</template>

<script>
export default {
  name: 'Watermark',
  computed: {
    userName() {
      // 从localStorage获取用户信息
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        try {
          const parsedInfo = JSON.parse(userInfo);
          return parsedInfo.name || parsedInfo.email || '用户';
        } catch (e) {
          return '用户';
        }
      }
      return '用户';
    },
    
    watermarkText() {
      return `爱标准 ${this.userName}`;
    },
    
    watermarkStyle() {
      // 创建包含用户名的水印
      const svgText = this.watermarkText;
      const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='200' height='100'>
        <text x='10' y='40' font-family='Arial' font-size='20' fill='rgba(126, 87, 194, 0.08)' transform='rotate(-30 60, 0)'>${svgText}</text>
      </svg>`;
      
      // 转换SVG为Base64编码
      const encodedSvg = encodeURIComponent(svg)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22');
      
      return {
        backgroundImage: `url("data:image/svg+xml;utf8,${encodedSvg}")`
      };
    }
  }
}
</script>

<style scoped>
.watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  background-repeat: repeat;
}
</style> 